export const profileTypes = [
  "trust",
  "individual",
  "soleTrader",
  "company",
  "plc",
  "partnership",
  "otherEntity",
];

export const trust = [
  "trustDeed",
  "structureChart",
  "meetingMinutes",
  "communications",
  "sourceOfWealth",
  "sourceOfFunds",
  "financials",
  "questionnaire",
  "passport",
  "nationalID",
  "proofOfAddress",
  "other",
];

export const individual = [
  "passport",
  "nationalID",
  "proofOfAddress",
  "sourceOfWealth",
  "questionnaire",
  "other",
];

export const soleTrader = [
  "passport",
  "nationalID",
  "proofOfAddress",
  "sourceOfWealth",
  "questionnaire",
  "financials",
  "other",
];

export const company = [
  "incorporationDocuments",
  "registrationDocuments",
  "shareRegister",
  "communications",
  "structureChart",
  "meetingMinutes",
  "sourceOfFunds",
  "questionnaire",
  "financials",
  "passport",
  "nationalID",
  "proofOfAddress",
  "other",
];

export const partnership = [
  "incorporationDocuments",
  "registrationDocuments",
  "shareRegister",
  "communications",
  "structureChart",
  "meetingMinutes",
  "sourceOfFunds",
  "questionnaire",
  "financials",
  "passport",
  "nationalID",
  "proofOfAddress",
  "other",
];

export const otherEntity = [
  "incorporationDocuments",
  "registrationDocuments",
  "shareRegister",
  "communications",
  "structureChart",
  "meetingMinutes",
  "sourceOfFunds",
  "questionnaire",
  "financials",
  "passport",
  "nationalID",
  "proofOfAddress",
  "other",
];

export const plc = [
  "incorporationDocuments",
  "registrationDocuments",
  "shareRegister",
  "communications",
  "evidenceOfListing",
  "meetingMinutes",
  "sourceOfFunds",
  "questionnaire",
  "financials",
  "passport",
  "nationalID",
  "proofOfAddress",
  "groupStructureDocumentation",
  "other",
];

export const ProfileTypeNames = {
  trust: "Trust",
  individual: "Individual",
  soleTrader: "Sole Trader",
  company: "Company",
  plc: "Public Limited Company (PLC)",
  partnership: "Partnership",
  otherEntity: "Other Entity",
};

export const AMLModalSections = {
  names: "names",
  categories: "categories",
  pepTiers: "pepTiers",
};

export const AMLModalAccordionHeaders = {
  categories: "AML Categories",
  pepTiers: "PEP Tiers",
};

export const individualSoleTraderCategories = [
  "SAN",
  "ENF",
  "INS",
  "DD",
  "PEP",
  "POI",
  "AM",
];

export const otherProfileTypeCategories = [
  "SAN",
  "ENF",
  "INS",
  "SOE",
  "PEP",
  "POI",
  "AM",
];

export const individualSoleTraderCategoriesSanctionEnabled = [
  "SAN-CURRENT",
  "SAN-FORMER",
  "ENF",
  "INS",
  "DD",
  "PEP-CURRENT",
  "PEP-FORMER",
  "PEP-LINKED",
  "POI",
  "AM",
];

export const otherProfileTypeCategoriesSanctionEnabled = [
  "SAN-CURRENT",
  "SAN-FORMER",
  "ENF",
  "INS",
  "SOE-CURRENT",
  "SOE-FORMER",
  "PEP-LINKED",
  "POI",
  "AM",
];

export const maximumNoteLength = 1000;

export const unassignedUser = "Unassigned";

export const kycStatus = [
  "new",
  "approved",
  "declined",
  "pending",
  "cancelled",
  "referred",
  "closed",
  "approvedReviewDue",
];

export const entityAndKeyPartyTypes = {
  individual: "individual",
  business: "business",
  shareholder: "shareholder",
  ubo: "ubo",
  director: "director",
};

export const riskRatingEnums = [
  "notApplicable",
  "veryHigh",
  "high",
  "medium",
  "low",
  "veryLow",
];

export const profileSortTypes = ["lastModified", "name"];

export const profileSortTypeNames = {
  lastModified: "lastModified",
  ascending: "asc",
  descending: "desc",
  modifiedAt: "modifiedAt",
  name: "name",
};

export const exportProfileType = {
  plc: "plc",
  otherEntity: "otherEntity",
};

export const ModeOfCreations = {
  import: "import",
  batchUpload: "batchUpload",
  manual: "manual",
};

export const profileCreationSource = {
  checkAndDecide: "checkAndDecide",
};

export const AddressTypes = {
  other: "other",
  trading: "trading",
  registered: "registered",
};

export const profileExportErrorTypes = {
  profileConflict: "ProfileConflict",
  companyReportNotFound: "CompanyReportNotFound",
  companyReportNotFoundMessage: "No objects found for the given id.",
  profileConflictMessage: "Profile Already Exists",
};

export const profileActionsErrorTitles = {
  profileLocked: "Profiles Are Locked",
};

export const turnOverOnlyTypes = [
  "soleTrader",
  "company",
  "plc",
  "partnership",
  "otherEntity",
];

export const hiddenSection = ["individual", "soleTrader"];

export const lockedScheduleConflict = "LockedScheduleConflict";

export const validationType = "Validation";
